module.exports = __webpack_public_path__ + "img/icon_anonbud_bronze.8c46ba0e.svg";